import React, { useEffect, useState } from "react";
import './ToastMessage.css'
export default function ToastMessage(props) {
  const [disableToast, setDisableToast] = useState(false);
  useEffect(() => {
   
    setTimeout(() => {
      setDisableToast(true);
      props.clickedOnToast()
    }, 2000);
  },
   []);

 

  return (
    <>
      {!disableToast && (
        <div className="ToastMessageContainer" >

        
        <div className="ToastMessageContainer-inner" >
          <div className="toast-message-left">{props.message}</div>
          <div className="toast-message-right" onClick={()=>{
            setDisableToast(true)
            props.clickedOnToast()
          }} > X </div>
        </div>
        </div>
      )}
    </>
  );
}
